import { API } from '@Providers';

export default async function resendStaffEmailVerificationService(staffId: string) {
  const endpoint = `/api/shelter/users/${staffId}/email-verification/resend`;

  return API({ endpoint, method: 'post' });
}
